import { cartMobx, storeMobx, orderMobx, discountMobx, queueMobx } from 'restaurant'
import { checkoutMobx, timePickMobx, memberMobx, deliveryMobx, queueOrderingMobx, payPlanMobx, orderLiveMobx, advertMobx, thirdPartyMobx } from '@mobxStore'
import { trace } from '@dt/fe-utils'
import { modalLayer, loadingLayer, toastLayer } from '@utils'
import { cloneDeep } from '@dt/fe-utils/dist/lodash'
import { CheckoutPayController, RestoreOrderController, CashierController } from '@ctrls/index'
import { WaiterModal } from '@pages/checkout/modal'

interface ISaveOrderProps {
  isRepeat?: boolean;
  handlePayAction?: () => void;
  handleSaveError?: () => void;
}

interface IPayOrderProps extends ISaveOrderProps {
  history: any;
  handlePayError?: (forceOrder?: boolean) => void;
}

let isPayOrdering = false

const toPay = async (ordersId: string) => {
  if (cartMobx.info.payMode) {
    payPlanMobx.updateOrder({ uniqueKey: ordersId })
  }
  const prepayCreate = await orderMobx.startPay(ordersId)
  try {
    trace.traceLog({
      name: '支付: => 支付startPay回调',
      message: { error: prepayCreate, ordersId }
    })
  } catch (error) {
  }
  return await CheckoutPayController.doPay(prepayCreate)
}

// 重算营销、支付方案
export const payOrderReset = async (forceOrder?: boolean) => {
  // 重新拉取订单
  if (forceOrder) {
    await orderMobx.init(cartMobx.ordersId)
  }
  // 重算优惠
  await new Promise((resolve, reject) => {
    discountMobx.calcCart()
    setTimeout(resolve, 100)
  })
  // 重算支付
  // payPlanMobx.endCalc()
  await new Promise((resolve, reject) => {
    payPlanMobx.beginCalc()
    setTimeout(resolve, 100)
  })
}

// 下单
export const saveOrder = async (params: ISaveOrderProps = {}) => {
  const { isRepeat, handlePayAction, handleSaveError } = params || {}
  const { info: storeInfo } = storeMobx
  const { cartResult, info: cartInfo } = cartMobx
  const isCanOrder = cartMobx.cartResult.totalCnt && cartResult.isCanSave && (((storeInfo.isMobileBookingOrder || timePickMobx.timePickList.length) && (cartInfo.startTime || (cartInfo.startTime === '' && storeInfo.inSale))) || storeInfo.inSale)
  const isCanDelivery = (cartMobx.info.eatType === 'delivery' && cartMobx.cartResult.itemActualPrice >= deliveryMobx.leastFee) || cartMobx.info.eatType !== 'delivery'
  const isCanSingleSale = cartMobx.canSingleSale
  const verifyAddress = cartMobx.info.eatType === 'delivery' ? deliveryMobx.verifyAddress() : true

  // 当前不可下单的状态
  if (!isCanOrder || !isCanDelivery || !isCanSingleSale || !verifyAddress) {
    if (!isCanDelivery || !isCanSingleSale || !verifyAddress) {
      modalLayer.closeAll()
    }
    return false
  }

  // 当前如果是待接单的并且没有任何修改则不重新下单
  if (cartMobx.isWait && !orderLiveMobx.needReorder) {
    return false
  }

  // loading
  loadingLayer.show()

  // 处理用户的case(当游客勾选了需要保存信息才创建虚拟用户)
  if (!Config.token && checkoutMobx.isSaveOrderInfo) {
    try {
      const memberId = await memberMobx.virtualMember({
        nickName: checkoutMobx.contactInfo.contactName || checkoutMobx.contactInfo.contactMobile,
      })
      if (memberId) {
        discountMobx.setVirtualMemberId(memberId)
      }
    } catch (err) {
      console.error(err)
    }
  }

  // 如果已经下过单为了防止订单已经被修改，则需要后续重新做一次优惠
  const calcAgain = !!cartMobx.ordersId

  // table code
  if (Config.codeType === 'table' && cartInfo.tableCode.toString() !== Config.TABLECODE.toString()) {
    cartMobx.setTableCode(Config.TABLECODE)
  }

  // delivery contcat info
  if (cartInfo.eatType !== 'delivery') {
    cartMobx.setContact(checkoutMobx.checkoutContactInfos)
  }

  // 关闭等待支付的订单
  if (!cartMobx.info.payMode && cartMobx.ordersId && orderMobx?.order?.status === 'Paying') {
    try {
      await CheckoutPayController.resume(cartMobx.ordersId)
      const success = await cartMobx.cancel()
      success && cartMobx.clearOrdersId()
      success && cartMobx.replacePk()
    } catch (e) {
      loadingLayer.hide()
      if (e.message) {
        toastLayer.error({
          content: e.message,
          duration: 1000,
        })
      }
      return
    }
  }
  // save order
  return cartMobx.save().then(async (res: any) => {
    try {
      advertMobx.traceCartProductsFromAdvert(res)
    } catch (error) {
      console.log(error)
    }
    loadingLayer.hide()
    // if (!orderMobx.viewOrder.isWait) {
    //   // TODO 找个更好的方案
    //   restaurantCenter.off(orderLiveMobx.cartItemsChangedHandler)
    //   cartMobx.clear()
    // }
    // orderLiveMobx.setNeedReorder(false)
    // orderLiveMobx.setIsShowWaiter()
    // // 实际购物车需要计算的餐品发生变化 需要重新主动算一次
    // calcAgain && discountMobx.calcCart()
    // history.push('/checkout')
    const selectCouponIds = cloneDeep(discountMobx.discountAction.selectCouponIds)
    const selectItemCouponIds = cloneDeep(discountMobx.discountAction.selectItemCouponIds)
    discountMobx.setSelectCoupon(selectCouponIds, selectItemCouponIds)
    // if (!cartInfo.payMode && !isRepeat) {
    //   handlePayAction && handlePayAction()
    // }
    if (cartInfo.payMode) {
      const { confirmOrders, memberConfirmOrders } = storeMobx.storeSceneConfig
      if (!confirmOrders || (confirmOrders && memberConfirmOrders)) {
        modalLayer(WaiterModal, { isWaitForReceive: false }, 'waiterModal').catch(() => { })
      }
      // 排队下单跳转至桌台
      queueOrderingMobx.toTable(queueMobx.queueInfo)
    }
    return true
  }).catch(async (err: any) => {
    loadingLayer.hide()
    try {
      trace.traceLog(
        {
          name: '下单失败save => ',
          message: { err, memberInfo: memberMobx?.memberInfo }
        }
      )
    } catch (error) {
    }
    if (err.code === -118 || err.code === -395 || err.code === -165 || err.code === -161 || err.code === -166 || err.code === -167 || err.code === -168 || err.code === -1218) {
      // 处理订单未同步的case
      if (!isRepeat) {
        if (cartMobx.ordersId) {
          await orderMobx.init(cartMobx.ordersId)
        }
        // 删除重复pk(pk重复)
        if (err.code === -1218 && err.data?.length) {
          await cartMobx.remove(err.data)
        }
        // 实际购物车需要计算的餐品发生变化 需要重新主动算一次
        discountMobx.calcCart()
        await saveOrder({
          isRepeat: true,
          handlePayAction,
          handleSaveError,
        })
      } else {
        // 下单异常
        handleSaveError && handleSaveError()
      }
    } else {
      modalLayer.closeAll()
      await CashierController.handleSaveError(err, 'checkout')
    }
    return false
  })
}

// 支付
export const payOrder = async ({
  history,
  handlePayAction,
  handleSaveError,
  handlePayError
}: IPayOrderProps) => {
  // 非POS单手机扫码付
  if (!cartMobx.posOrderPay) {
    // 先付费先下单、无订单先下单
    if (!cartMobx.info.payMode || !cartMobx.ordersId) {
      const flag = await saveOrder({
        handlePayAction,
        handleSaveError
      })
      if (!flag) {
        return
      }
    }
  }

  // paying
  if (isPayOrdering) {
    return
  } else {
    isPayOrdering = true
  }

  // 支付准备(后付费自助支付、先付费、POS单手机扫码付)
  if ((cartMobx.info.payMode && (storeMobx.storeSceneConfig?.openAfterPayCustomerPay || !storeMobx.storeSceneConfig?.payMode)) || !cartMobx.info.payMode || cartMobx.posOrderPay) {
    try {
      // 强制同步营销计算优惠
      const isForce = !!(cartMobx.ordersId && cartMobx.info.payMode && (storeMobx.storeSceneConfig?.openAfterPayCustomerPay || !storeMobx.storeSceneConfig?.payMode)) || cartMobx.posOrderPay
      try {
        const checkMktFlag = await cartMobx.syncMkt(isForce)
        if (isForce && cartMobx.ordersId) {
          if (checkMktFlag) {
            await payOrderReset(!checkMktFlag)
          } else {
            handlePayError(true)
            isPayOrdering = false
            return
          }
        }
      } catch (e) {
        if (isForce && cartMobx.ordersId) {
          handlePayError(true)
          isPayOrdering = false
          return
        }
      }
      await CheckoutPayController.preparePay()
    } catch (e) {
      if (e.doc_url) {
        // 这个是stripe报的错。要等apple弹窗关闭后展示。
        setTimeout(() => {
          toastLayer.error({
            content: e.message,
            duration: 1000,
          })
        }, 2000)
      } else if (e.message) {
        toastLayer.error({
          content: e.message,
          duration: 1000,
        })
      }
      isPayOrdering = false
      return
    }
  }

  // loading
  loadingLayer.show()

  // 处理用户的case
  // 当游客勾选了需要保存信息才创建虚拟用户 modify: 22.02.10放到下单前
  // if (!Config.token && checkoutMobx.isSaveOrderInfo) {
  //   try {
  //     const memberId = await memberMobx.virtualMember({
  //       nickName: checkoutMobx.contactInfo.contactName || checkoutMobx.contactInfo.contactMobile,
  //     })
  //     if (memberId) {
  //       discountMobx.setVirtualMemberId(memberId)
  //     }
  //     // 限行置入营销结果，解决营销计算结果异步的问题
  //   } catch (err) {
  //     console.error(err)
  //   }
  // }

  // table code
  if (Config.codeType === 'table' && cartMobx.info.tableCode.toString() !== Config.TABLECODE.toString()) {
    cartMobx.setTableCode(Config.TABLECODE)
  }

  // delivery contact info
  if (cartMobx.info.eatType !== 'delivery') {
    cartMobx.setContact(checkoutMobx.checkoutContactInfos)
  }

  const _ordersId = cartMobx.ordersId

  if (!cartMobx.info.payMode && !Config.buyTogetherId) {
    RestoreOrderController.hold(_ordersId)
  }

  try {
    if (orderMobx.order?.ordersId && orderMobx.order?.ordersId !== _ordersId) {
      await cartMobx.setOrdersId(_ordersId)
    }
    const result = await toPay(_ordersId)
    if (result === 'async') {
      isPayOrdering = false
      loadingLayer.hide()
      return
    }
    timePickMobx.reset()
    thirdPartyMobx.clear('check')
    isPayOrdering = false
    loadingLayer.hide()
    payPlanMobx.setShowAllGiftCardList(false)
  } catch (e) {
    // TODO 细粒度控制生成新订单
    // 下单失败则清除购物车中的订单Id
    // cartMobx.clearOrdersId()
    CashierController.handleStartPayError(e)
    isPayOrdering = false
    loadingLayer.hide()
    history.replace({
      pathname: cartMobx.posOrderPay ? '/posPayfail' : '/payfail',
      state: {
        reason: e.message || e.reason
      }
    })
    trace.traceLog({
      name: '支付: => 支付异常',
      message: { error: e, ordersId: _ordersId }
    })
    return
  }
  RestoreOrderController.clearHold()
  // 先付费下单成功清理当前购物车的缓存,订单的缓存
  cartMobx.reset(cartMobx.info.payMode, cartMobx.info.eatType)
  // discountMobx.clearDiscountAction()
  memberMobx.refreshMemeberBenefits()
  // 支付成功后，重置时间
  CashierController.toResult(_ordersId)
}
